import React from 'react'
import {Form, FormText, Label, Input } from 'reactstrap';
import './StyleReturnReason.css';

export const FormReturnReason = (props) => {

    const {
        handleInputChange,
        methodAction,
        reason,
        validaciones,
        is_sample,
        is_work_order,
        is_tracking,
        is_send
    } = props;

    const {
        reason_valid,
    } = validaciones;

    return (
        <Form className="return-reason-form" role="form" onSubmit={methodAction}>
            <div className="reason-container">
                <Label className="reason-label">
                    Motivo de devolución o cancelación
                </Label>

                <textarea
                    name="reason"
                    value={reason}
                    onChange={handleInputChange}
                    className={`reason-textarea ${reason_valid ? "input-error" : ""}`}
                    placeholder="Describe el motivo de devolución o cancelación..."
                />

                <FormText color="danger" hidden={!reason_valid} className="mt-2">
                    Debes redactar la devolución
                </FormText>

            </div>

            <div className="switches-container">
                <div className="switch-card">
                    <div className="switch-icon bg-warning-light">
                        <i className="fa fa-file-text"></i>
                    </div>

                    <Label className="switch-title">
                        Orden
                    </Label>

                    <Label className="switch">
                        <Input type="checkbox" name="is_work_order" onChange={handleInputChange} checked={is_work_order}/>
                        <span className="slider round"></span>
                    </Label>

                </div>


                <div className="switch-card">
                    <div className="switch-icon bg-primary-light">
                        <i className="fa fa-flask"></i>
                    </div>

                    <Label className="switch-title">
                        Toma
                    </Label>

                    <Label className="switch">
                        <Input
                            type="checkbox"
                            name="is_sample"
                            onChange={handleInputChange}
                            checked={is_sample}
                        />
                        <span className="slider round"></span>
                    </Label>

                </div>

                <div className="switch-card">

                    <div className="switch-icon bg-success-light">
                        <i className="fa fa-truck"></i>
                    </div>

                    <Label className="switch-title">
                        Envíos
                    </Label>

                    <Label className="switch">
                        <Input
                            type="checkbox"
                            name="is_send"
                            onChange={handleInputChange}
                            checked={is_send}
                        />
                        <span className="slider round"></span>
                    </Label>
                </div>

                 <div className="switch-card">
                    <div className="switch-icon bg-info-light">
                        <i className="fa fa-heartbeat"></i>
                    </div>

                    <Label className="switch-title">
                        Analítica
                    </Label>

                    <Label className="switch">
                        <Input
                            type="checkbox"
                            name="is_tracking"
                            onChange={handleInputChange}
                            checked={is_tracking}
                        />
                        <span className="slider round"></span>
                    </Label>

                </div>

            </div>

        </Form>
    )
}